import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { waLink, COMPANY } from "../lib/contact";

export const FloatingWhatsApp = () => {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowTip(true), 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-3">
      {showTip && (
        <div
          data-testid="floating-tip"
          className="hidden sm:flex items-center gap-3 bg-white border-2 border-[#0f172a] px-4 py-3 shadow-[4px_4px_0_#0f172a] max-w-xs"
        >
          <button
            onClick={() => setShowTip(false)}
            data-testid="floating-tip-close"
            className="absolute -top-2 -right-2 w-6 h-6 bg-[#0f172a] text-white border-2 border-[#0f172a] flex items-center justify-center"
            aria-label="Fechar"
          >
            <X className="w-3 h-3" strokeWidth={3} />
          </button>
          <div>
            <p className="text-xs font-extrabold uppercase tracking-wider text-[#027ec3]">
              {COMPANY.name}
            </p>
            <p className="text-sm font-bold text-[#0f172a] leading-tight mt-0.5">
              Olá! Vamos te atender agora pelo WhatsApp.
            </p>
          </div>
        </div>
      )}
      <a
        href={waLink("Olá! Quero falar com a PJ Caçambas e pedir um orçamento.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Abrir conversa no WhatsApp"
        className="pulse-whats relative w-16 h-16 md:w-[68px] md:h-[68px] bg-[#25d366] border-2 border-[#0f172a] flex items-center justify-center hover:bg-[#1ebe57] transition-colors shadow-[4px_4px_0_#0f172a]"
      >
        <MessageCircle className="w-8 h-8 text-white" strokeWidth={2.5} />
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#fff505] border-2 border-[#0f172a]" />
      </a>
    </div>
  );
};

export default FloatingWhatsApp;
